import { useCallback } from "react"

import { confirmationResponse, type ConfirmationRequest } from "../presentation/responses/confirmation"
import { usePresenter } from "./application-provider"

/** Asks the user to confirm and resolves to their answer. */
export type Confirm = (request: ConfirmationRequest | string, signal?: AbortSignal) => Promise<boolean>

/**
 * An awaitable replacement for `window.confirm`, shown by the application's presenter as a dialog. A plain text is the
 * message. Because it returns a promise, an async flow such as an edit that needs the user's consent can simply await it.
 */
export function useConfirm(): Confirm {
  const presenter = usePresenter()
  return useCallback(
    (request, signal) =>
      presenter.present(confirmationResponse, typeof request === "string" ? { message: request } : request, signal),
    [presenter]
  )
}
